var map = {
	"./01-01.mp3": 491,
	"./01-01__.mp3": 763,
	"./01-02.mp3": 764,
	"./01-03.mp3": 357,
	"./01-04.mp3": 358,
	"./01-05.mp3": 492,
	"./01-06.mp3": 765,
	"./01-07.mp3": 766,
	"./01-08.mp3": 767,
	"./01-09.mp3": 768,
	"./01-10.mp3": 769,
	"./01-11.mp3": 807,
	"./01-12.mp3": 1529,
	"./01-13.mp3": 1530,
	"./01-14.mp3": 808,
	"./04-01.mp3": 1531,
	"./04-02.mp3": 1532,
	"./04-03.mp3": 809,
	"./04.mp3": 1533,
	"./emotion-slow.mp3": 810,
	"./emotion.mp3": 1534,
	"./ex1-slow.mp3": 811,
	"./ex1.mp3": 1535,
	"./ex1_3_4-slow.mp3": 812,
	"./ex1_3_4.mp3": 1536,
	"./ex7-slow.mp3": 813,
	"./ex7.mp3": 1537,
	"./ex8-slow.mp3": 814,
	"./ex8.mp3": 1538,
	"./health-slow.mp3": 815,
	"./health.mp3": 1539,
	"./intoSleep.mp3": 500,
	"./life-cycle-slow.mp3": 816,
	"./life-cycle.mp3": 1540,
	"./life-slow.mp3": 817,
	"./life.mp3": 1541,
	"./natureFeedback.mp3": 1542,
	"./natureFeedbackEffect.mp3": 818,
	"./recognition-slow.mp3": 819,
	"./recognition.mp3": 1543,
	"./soundAlpha.mp3": 1544,
	"./soundAlpha1.mp3": 1545,
	"./soundAlpha2.mp3": 1546,
	"./soundAttemption.mp3": 770,
	"./soundAttemptionNew.mp3": 1547,
	"./soundBalance.mp3": 772,
	"./soundBalanceF.mp3": 1548,
	"./soundBalanceNew.mp3": 1549,
	"./soundConst.mp3": 771,
	"./soundConstNew.mp3": 1550,
	"./soundRest.mp3": 359,
	"./soundRestNew.mp3": 1551,
	"./view5-ex1-slow.mp3": 820,
	"./view8-ex1-slow.mp3": 821,
	"./view9-ex1-slow.mp3": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1528;